import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ConfigurationService from '../../../../services/ConfigurationService';
import { translate } from '../../../../utils/util';
import { Button, Input, BackButton, Title, Subtitle } from '../../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../../utils/constants';

const PickingHome = (props) => {
    const [configs, setConfigs] = useState([]);

    useEffect(() => {
        props.configs(props.user.vision, { moduleId: ENUMS.eModules.Picking.value }, (response) => {
            const items = [];

            if (response.items) {
                response.items.map((event) => {
                    for (let i = 0; i < items.length; i += 1) {
                        if (items[i].key === event.key) {
                            items[i].value = event.value;
                            items[i].configId = event.configId;
                        }
                    }
                    return event;
                });
            }
            setConfigs(items);
        });
        // eslint-disable-next-line
    }, []);

    const onConfirm = () => {
        props.configsPut(props.user.vision, configs, () => {
            props.history.go(-1);
        });
    };

    const onChange = (index) => (event) => {
        const newArr = [...configs];
        if (event.target.type === 'checkbox') {
            newArr[index].value = (event.target.checked ? '1' : undefined);
        } else {
            newArr[index].value = event.target.value;
        }

        setConfigs(newArr);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                    <Subtitle icon="mdi mdi-clipboard-check" label={translate('menu.picking', 'configuration')} />
                </div>
            </div>
            {
                configs && configs.length > 0 && (
                    <div className="container-fluid" style={{ marginTop: '25px', }}>
                        <div className="container">
                            <div className="card">
                                <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        {
                                            configs && configs.map((item, index) => (
                                                <div key={item.key} className="input-field no-padding col s12">
                                                    {
                                                        item.type === 'checkbox'
                                                            ? <Input type={item.type} key={item.key} label={translate(item.label, 'configuration')} id={item.key} onClick={onChange(index)} defaultChecked={item.value} />
                                                            : <Input type={item.type} key={item.key} label={translate(item.label, 'configuration')} id={item.key} onChange={onChange(index)} defaultValue={item.value} />
                                                    }
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className="row" style={{ paddingTop: '15px' }}>
                                        <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                        <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        configs: (vision, filter, callback) => {
            dispatch(ConfigurationService.getConfigs(filter, callback));
        },
        configsPut: (vision, data, callback) => {
            dispatch(ConfigurationService.putConfig(vision, data, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingHome)));
